import { IsLoadingReducerState } from './types';

export const defaultState: IsLoadingReducerState = {
  global: 0,
  pages: []
};
